// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalTasksHeaderDataQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID']['input'];
  scheduleId: Types.Scalars['ID']['input'];
}>;


export type GlobalTasksHeaderDataQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] } }>, schedule: { __typename?: 'Schedule', id: string, templateSchedule?: { __typename?: 'Schedule', id: string, parent:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Development', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
        | { __typename?: 'ScheduleTemplate', id: string, name: string }
       } | null | undefined, parent:
      | { __typename?: 'StandaloneProject', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Region', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Development', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Market', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Community', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Subdivision', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Lot', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Structure', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'Unit', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
      | { __typename?: 'ScheduleTemplate', id: string, schedules: Array<{ __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } }> }
     } };

export type StageDetailForScheduleFragment = { __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string } };

export const StageDetailForScheduleFragmentDoc = gql`
    fragment StageDetailForSchedule on Schedule {
  id
  stageDetail {
    code
    name
  }
}
    `;
export const GlobalTasksHeaderDataDocument = gql`
    query GlobalTasksHeaderData($parentId: ID!, $scheduleId: ID!) {
  scheduleTasks(
    filter: {isGlobalMilestoneTask: true, scheduleParent: [$parentId]}
  ) {
    id
    name
    interval {
      startDate
      endDate
    }
  }
  schedule(id: $scheduleId) {
    id
    templateSchedule {
      id
      parent {
        ... on Named {
          id
          name
        }
      }
    }
    parent {
      ... on HasSchedules {
        id
        schedules {
          ...StageDetailForSchedule
        }
      }
    }
  }
}
    ${StageDetailForScheduleFragmentDoc}`;

/**
 * __useGlobalTasksHeaderDataQuery__
 *
 * To run a query within a React component, call `useGlobalTasksHeaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalTasksHeaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalTasksHeaderDataQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGlobalTasksHeaderDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables> & ({ variables: GlobalTasksHeaderDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>(GlobalTasksHeaderDataDocument, options);
      }
export function useGlobalTasksHeaderDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>(GlobalTasksHeaderDataDocument, options);
        }
// @ts-ignore
export function useGlobalTasksHeaderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>;
export function useGlobalTasksHeaderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalTasksHeaderDataQuery | undefined, GlobalTasksHeaderDataQueryVariables>;
export function useGlobalTasksHeaderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>(GlobalTasksHeaderDataDocument, options);
        }
export type GlobalTasksHeaderDataQueryHookResult = ReturnType<typeof useGlobalTasksHeaderDataQuery>;
export type GlobalTasksHeaderDataLazyQueryHookResult = ReturnType<typeof useGlobalTasksHeaderDataLazyQuery>;
export type GlobalTasksHeaderDataSuspenseQueryHookResult = ReturnType<typeof useGlobalTasksHeaderDataSuspenseQuery>;
export type GlobalTasksHeaderDataQueryResult = ApolloReactCommon.QueryResult<GlobalTasksHeaderDataQuery, GlobalTasksHeaderDataQueryVariables>;